import React,{useEffect,useState} from 'react';
import {useNavigate} from 'react-router-dom';
import API from '../utils/api';

const fmt=value=>value?new Date(value).toLocaleString('zh-CN',{hour12:false}):'-';
export default function OwnerCommunity(){
  const navigate=useNavigate();
  const [tab,setTab]=useState('notices');
  const [data,setData]=useState({notices:[],votes:[]});
  const [loading,setLoading]=useState(true);const [selectedNotice,setSelectedNotice]=useState(null);
  const load=()=>API.get('/community/owner').then(r=>setData(r.data));
  useEffect(()=>{load().catch(e=>alert(e.response?.data?.message||'加载失败')).finally(()=>setLoading(false));const timer=setInterval(()=>load().catch(()=>{}),30000);return()=>clearInterval(timer);},[]);
  const ballot=(vote,index)=>{if(!window.confirm(`确定选择“${vote.options[index]}”吗？提交后不能修改。`))return;API.post(`/community/votes/${vote.id}/ballot`,{option_index:index}).then(r=>{alert(r.data.message);return load();}).catch(e=>alert(e.response?.data?.message||'投票失败'));};
  return <div style={s.page}>
    <header style={s.header}><button style={s.back} onClick={()=>navigate('/')}>← 返回</button><div><div style={s.title}>📣 物业通告与投票</div><div style={s.sub}>大诚瓯江印象物业服务中心</div></div></header>
    <div style={s.tabs}><button style={{...s.tab,...(tab==='notices'?s.tabOn:{})}} onClick={()=>setTab('notices')}>物业通告</button><button style={{...s.tab,...(tab==='votes'?s.tabOn:{})}} onClick={()=>setTab('votes')}>业主投票 {data.votes.some(v=>v.effective_status==='open'&&!v.has_voted)?'●':''}</button></div>
    <main style={s.body}>{loading?<div style={s.empty}>加载中...</div>:tab==='notices'?<NoticeList notices={data.notices} selected={selectedNotice} onSelect={setSelectedNotice}/>:<VoteList votes={data.votes} onBallot={ballot}/>}</main>
  </div>;
}
function NoticeList({notices,selected,onSelect}){
  const imageUrl=n=>n?.image_path
    ?'/uploads/'+encodeURIComponent(
      String(n.image_path).split(/[\\/]/).pop()
    )
    :'';

  if(selected)return <article style={s.card}>
    <button onClick={()=>onSelect(null)}>
      ← 返回通告列表
    </button>

    <h2>{selected.title}</h2>

    <div style={s.meta}>
      {selected.created_name||'物业服务中心'} ·
      {fmt(selected.created_at)}
    </div>

    {selected.image_path?
      <img
        src={imageUrl(selected)}
        alt="物业通告配图"
        style={{
          display:'block',
          width:'100%',
          maxHeight:520,
          objectFit:'contain',
          borderRadius:10,
          background:'#f5f5f5',
          margin:'16px 0'
        }}
      />
    :null}

    <div style={{
      ...s.content,
      fontSize:16,
      marginTop:18
    }}>
      {selected.content}
    </div>
  </article>;

  return notices.length?
    notices.map(n=>
      <button
        key={n.id}
        onClick={()=>onSelect(n)}
        style={{
          ...s.card,
          width:'100%',
          border:0,
          textAlign:'left'
        }}
      >
        <h3 style={s.h3}>{n.title}　›</h3>

        {n.image_path?
          <img
            src={imageUrl(n)}
            alt=""
            style={{
              width:'100%',
              height:140,
              objectFit:'cover',
              borderRadius:9,
              margin:'6px 0 10px'
            }}
          />
        :null}

        <div style={{color:'#666',fontSize:13}}>
          {String(n.content||'').replace(/\s+/g,' ').slice(0,60)}
          {String(n.content||'').length>60?'…':''}
        </div>

        <div style={s.meta}>
          {n.created_name||'物业服务中心'} ·
          {fmt(n.created_at)}
        </div>
      </button>
    )
  :<div style={s.empty}>暂无物业通告</div>
}
function VoteList({votes,onBallot}){return votes.length?votes.map(v=><article style={s.card} key={v.id}><div style={s.voteHead}><h3 style={s.h3}>{v.title}</h3><span style={v.effective_status==='open'?s.open:s.ended}>{v.effective_status==='open'?'投票中':'已截止'}</span></div><div style={s.content}>{v.description}</div><div style={s.deadline}>截止时间：{fmt(Number(v.deadline_ts))}</div>{v.effective_status==='open'?(v.has_voted?<div style={s.voted}>✓ 您所在房号已投票：{v.options[v.my_option_index]}</div>:<div style={s.choices}>{v.options.map((o,i)=><button key={i} style={s.choice} onClick={()=>onBallot(v,i)}>{o}</button>)}</div>):<Result results={v.results||[]} total={v.total_ballots}/>}<div style={s.participation}>已有 {v.total_ballots} 户参与</div></article>):<div style={s.empty}>暂无业主投票</div>}
function Result({results,total}){return <div style={s.result}><b>最终投票结果（共{total}票）</b>{results.map(r=><div key={r.index} style={s.resultItem}><div style={s.resultLine}><span>{r.label}</span><b>{r.count}票 · {r.percentage}%</b></div><div style={s.track}><div style={{...s.fill,width:`${r.percentage}%`}}/></div></div>)}</div>}
const s={page:{minHeight:'100vh',background:'#f3f6fa'},header:{display:'flex',alignItems:'center',gap:12,background:'linear-gradient(135deg,#173f73,#2d7dd2)',color:'#fff',padding:'18px 15px'},back:{border:'none',borderRadius:16,background:'#ffffff22',color:'#fff',padding:'7px 11px'},title:{fontSize:21,fontWeight:800},sub:{fontSize:12,opacity:.85,marginTop:4},tabs:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,padding:10,background:'#fff',position:'sticky',top:0,zIndex:3},tab:{border:'none',borderRadius:17,padding:9,background:'#edf1f6',color:'#536174'},tabOn:{background:'#1a5da8',color:'#fff'},body:{padding:13,maxWidth:760,margin:'0 auto'},card:{background:'#fff',borderRadius:13,padding:15,marginBottom:11,boxShadow:'0 2px 9px #0000000d'},h3:{fontSize:17,margin:'0 0 8px'},content:{whiteSpace:'pre-wrap',lineHeight:1.75,fontSize:14,color:'#333'},meta:{fontSize:12,color:'#999',marginTop:12},voteHead:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:8},open:{fontSize:11,color:'#389e0d',background:'#f0fff0',padding:'4px 8px',borderRadius:10,whiteSpace:'nowrap'},ended:{fontSize:11,color:'#666',background:'#eee',padding:'4px 8px',borderRadius:10,whiteSpace:'nowrap'},deadline:{fontSize:12,color:'#cf5b18',marginTop:10},choices:{display:'grid',gap:9,marginTop:13},choice:{border:'1px solid #aac7e8',borderRadius:9,background:'#eef6ff',color:'#174f87',padding:'11px',fontSize:14,fontWeight:700,textAlign:'left'},voted:{background:'#f0fff0',color:'#2d7d12',borderRadius:9,padding:11,fontSize:13,marginTop:13},participation:{fontSize:12,color:'#888',marginTop:11},result:{borderTop:'1px solid #eee',marginTop:13,paddingTop:12},resultItem:{marginTop:10},resultLine:{display:'flex',justifyContent:'space-between',gap:8,fontSize:12},track:{height:8,background:'#e8edf3',borderRadius:4,marginTop:5,overflow:'hidden'},fill:{height:'100%',background:'#2d7dd2',borderRadius:4},empty:{textAlign:'center',color:'#999',padding:35}};
